var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34084 17.0906C2.50186 17.1194 2.66504 17.1419 2.82966 17.158C3.02973 17.1775 3.2326 17.1875 3.4375 17.1875C4.64319 17.1875 5.76993 16.842 6.72207 16.2445C7.43133 16.4115 8.17373 16.5 8.9375 16.5C13.816 16.5 17.875 12.8614 17.875 8.25C17.875 3.63856 13.816 0 8.9375 0C4.05899 0 0 3.63856 0 8.25C0 10.4579 0.939213 12.4549 2.4509 13.9263C2.66357 14.1333 2.70515 14.318 2.6842 14.4236C2.569 15.0044 2.30713 15.533 1.93744 15.9694C1.77848 16.157 1.73183 16.4152 1.81508 16.6466C1.89832 16.8779 2.0988 17.0472 2.34084 17.0906ZM5.5 7.21875C4.93046 7.21875 4.46875 7.68046 4.46875 8.25C4.46875 8.81954 4.93046 9.28125 5.5 9.28125C6.06954 9.28125 6.53125 8.81954 6.53125 8.25C6.53125 7.68046 6.06954 7.21875 5.5 7.21875ZM7.90625 8.25C7.90625 7.68046 8.36796 7.21875 8.9375 7.21875C9.50704 7.21875 9.96875 7.68046 9.96875 8.25C9.96875 8.81954 9.50704 9.28125 8.9375 9.28125C8.36796 9.28125 7.90625 8.81954 7.90625 8.25ZM12.375 7.21875C11.8055 7.21875 11.3438 7.68046 11.3438 8.25C11.3438 8.81954 11.8055 9.28125 12.375 9.28125C12.9445 9.28125 13.4062 8.81954 13.4062 8.25C13.4062 7.68046 12.9445 7.21875 12.375 7.21875Z",
    fill: "#232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTemplate);
export default __webpack_public_path__ + "static/media/message_template.7f58262fb32a8ca646a4755726e7686d.svg";
export { ForwardRef as ReactComponent };